import React, {Component} from 'react';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';
import  BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import ClaimFormatterFunctions from './ClaimFormatters';
import {SERVER_URL}  from '../Constants';
import LostItemFunctions from '../LostItem/LostItemFunctions';
import Modal from 'react-responsive-modal';
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css"

const { SearchBar } = Search;
const paginationOption = {
  custom: true,
  sizePerPage: 50
};



const stadiumColums = [
  { dataField: 'id', hidden:true, text: 'id', headerStyle: (colum, colIndex) => {return { width: '50px', textAlign: 'left', classes:'text-secondary' };} },
  { dataField: 'lastName',classes:'text-primary', text: 'Name', sort: true,formatter: ClaimFormatterFunctions.nameFormatter, textAlign: 'left'},
  { dataField: 'status', text: 'Stage',classes:ClaimFormatterFunctions.statusColFormater, formatter:ClaimFormatterFunctions.stageFormatter, filterable:true, sort: true, textAlign: 'left' },
  { dataField: 'category', classes:'text-primary', text: 'category',sort: true,},
  { dataField: 'subcat', classes:'text-primary', text: 'subcategory',sort: true, },
  { dataField: 'brand', classes:'text-primary', text: 'brand',sort: true, },
  { dataField: 'color', classes:'text-primary', text: 'color',sort: true, },
  { dataField: 'lostItemShortDescription', classes:'text-primary', text: 'Item Description',sort: true, },
  { dataField: 'section', classes:'text-primary text-center', text: 'Section',sort: true, headerStyle: (colum, colIndex) => { return { width: '25px', textAlign: 'center' };}},
  { dataField: 'row', classes:'text-primary text-right', text: 'row',sort: true, headerStyle: (colum, colIndex) => { return { width: '35px', textAlign: 'center' };}},
  { dataField: 'seat', classes:'text-primary text-center', text: 'Seat',sort: true, headerStyle: (colum, colIndex) => { return { width: '25px', textAlign: 'center' };}},
  { dataField: 'parkingLot', classes:'text-primary text-center', text: 'Lot',sort: true, headerStyle: (colum, colIndex) => { return { width: '150px', textAlign: 'center' };}},
  { dataField: 'locationLost', classes:'text-primary text-center', text: 'Location Dec.',sort: true, headerStyle: (colum, colIndex) => { return { width: '150px', textAlign: 'center' };}},
  { dataField: 'topMatchPct', text: 'Top Match %',sort: true,classes:ClaimFormatterFunctions.matchColFormater, formatter:ClaimFormatterFunctions.formatPct, headerStyle: (colum, colIndex) => { return { width: '25px', textAlign: 'center' };}},
  { dataField: 'totalMatches', classes:'text-primary text-center', text: '#Matches',sort: true,headerStyle: (colum, colIndex) => { return { width: '25px', textAlign: 'center' };}},
  { dataField: 'claimDate', text: 'Claim Date',classes:'text-primary',formatter:ClaimFormatterFunctions.formatDateTime, sort: true, headerStyle: (colum, colIndex) => {return { width: '190px', textAlign: 'center' };}},
];


// AIRLINE
const airlineMatchColumns = [
  { dataField: 'itemNumber',classes:'text-primary', sort: true, text: 'Item#', filterable:true,  textAlign: 'left', headerStyle: {width:'50px'} },
  { dataField: 'url', text: 'Picture', formatter: imageFormat },
  { dataField: 'shortDescription',classes:'text-primary', sort: true, text: 'Item', filterable:true,  textAlign: 'left', headerStyle: {width:'200px'} },
  { dataField: 'longDescription',sort: true, text: 'Description',  textAlign: 'left', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '320px', textAlign: 'center' };}},
  { dataField: 'airportCd',sort: true, classes:'text-primary', text: 'Airport',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'flightNumber',sort: true, classes:'text-primary', text: 'Flight#',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'seat',sort: true, classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'terminal',sort: true, classes:'text-primary', text: 'Terminal',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'gate',sort: true, classes:'text-primary', text: 'Gate / Lounge',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'itemState',classes:LostItemFunctions.statusColFormater, sort: true,formatter: LostItemFunctions.itemStatusDesc, text: 'Status',  textAlign: 'left'},
  { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found',  headerStyle: (colum, colIndex) => {return { width: '190px', textAlign: 'center' };}},
  { dataField: 'foundByName',sort: true, text: 'Found By',classes:'text-primary' },
  { dataField: 'returnedDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary', text: 'Returned On',  headerStyle: (colum, colIndex) => {return { width: '100px', textAlign: 'center' };}},
  { dataField: 'keywords',sort: true, text: 'keywords', },
  { dataField: 'storageLocation',sort: true, text: 'Storage Loc.', classes:'text-primary', },
  { dataField: 'id',sort: true,  text: 'Confirm', classes:'text-primary', }
];

// Stadium
const stadiumMatchColumns = [
  { dataField: 'itemNumber',classes:'text-primary', sort: true, text: 'Item#', filterable:true,  textAlign: 'left', headerStyle: {width:'50px'} },
  { dataField: 'url', text: 'Picture', formatter: imageFormat },
  { dataField: 'shortDescription',classes:'text-primary', sort: true, text: 'Item', filterable:true,  textAlign: 'left', headerStyle: {width:'200px'} },
  { dataField: 'longDescription',sort: true, text: 'Description',  textAlign: 'left', classes:'text-primary',headerStyle: (colum, colIndex) => {return { width: '320px', textAlign: 'center' };}},
  { dataField: 'section',sort: true, classes:'text-primary', text: 'Section',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'row',sort: true, classes:'text-primary', text: 'Row',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'seat',sort: true, classes:'text-primary', text: 'Seat',  headerStyle: (colum, colIndex) => {return { width: '90px', textAlign: 'center' };}},
  { dataField: 'parkingLot',sort: true, classes:'text-primary', text: 'Lot',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'locationLost',sort: true, classes:'text-primary', text: 'Location Desc.',  headerStyle: (colum, colIndex) => {return { width: '70px', textAlign: 'center' };}},
  { dataField: 'itemState',classes:LostItemFunctions.statusColFormater, sort: true,formatter: LostItemFunctions.itemStatusDesc, text: 'Status',  textAlign: 'left'},
  { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found',  headerStyle: (colum, colIndex) => {return { width: '190px', textAlign: 'center' };}},
  { dataField: 'foundByName',sort: true, text: 'Found By',classes:'text-primary' },
  { dataField: 'returnedDate',sort: true,formatter: LostItemFunctions.formatDate, classes:'text-primary', text: 'Returned On',  headerStyle: (colum, colIndex) => {return { width: '100px', textAlign: 'center' };}},
  { dataField: 'keywords',sort: true, text: 'keywords', },
  { dataField: 'storageLocation',sort: true, text: 'Storage Loc.', classes:'text-primary', },
  { dataField: 'id',sort: true,  text: 'Confirm', classes:'text-primary', }
];






const defaultSorted = [{
  dataField: 'foundDate',
  order: 'asc'
}];



function formatMatchPct(cell,row){
  try {
    if (row.topMatchPct){
      let pctValue= Math.round((row.topMatchPct * 100));
      if (pctValue >= 90){
        return(<h6 className='text-success'>{pctValue} </h6>)
      }else if (pctValue > 70){
        return(<h6 className='text-warning'>{pctValue}</h6>)
      }else{
        return(<h6 className='text-primary'>{pctValue}</h6>)
      }
  }
  
  }catch(e){
      return(null);
    }
  
 
}

function imageFormat(cell, row){
  if (row.url){
      return (
          <img  src={row.url} width={75} alt={row.shortDescription} />
      )
  }else{
    return (
      <img  src='../default-placeholder.png' width={75} alt={row.shortDescription} />
  )
  }
}


  


class AIM extends Component {
  constructor(props) {
    super(props);
    
    //console.log(this.props.match.params.id);
    this.initialClaimID = this.props.match.params.id;

    this.state = {
      initialClaimID:  this.initialClaimID,
        claims: [],
        filteredClaims:[],
        matchedItems:[],
        isChecked: false,
        openCount:0,
        closedCountShipped:0,
        closedCountPickedUp:0,
        waitingToShipCount:0,
        WaitingForPickupCount:0,
        archivedCount:0,
        unlinkedCount:0,
        showNewClaim: false,
        allCount:0,
        labelRequested:0,
        initialFilter: this.props.match.params.filter,
        venueTypeCd:'',
        matchCount:0,
        showCards :false,
        selected: -1,
        selectedClaimId :'',
        refreshButtonTitle: 'Refresh',
        displayNotes:false,
        isLoadingMatches:false,
        displayConfirmMatch: false,
        selectedLostItem : undefined,
        selectedClaim:undefined,
        displayLargeImageModal:false,
        selectedImageUrl:'',
        rebuildTitle:'Rematch All Claims',
        isLoading :false,
        includeImage:false,
    };

    





    this.rowMatchEvents ={
      onClick: (e, row, rowIndex) => {
       // alert(row)
       // this.props.history.push('/LostItem/' + row.id);
      },

    }

    this.rowEvents = {
        onClick: (e, row, rowIndex) => {
          
          //this.props.history.push('/Claim/' + row.id);
          //console.log(this + ' ' + `clicked on row with index: ${rowIndex}`);
          
         // this.loadmatches(row);
          //window.scrollTo(0, 900);
        },
        
      };
      axios.interceptors.response.use(response => {
        return response;
      }, error => {
       
       if (error.response.status === 401) {
        ToastStore.error("error unauthorized.  Your session has expired. Please log in again");
        
       }else{
         //console.log(error.response.data);
        ToastStore.error(error.response.data);
       }
       return error;
      });

  }

  async componentDidMount() {
   
   // set venueTypeCode
   this.setState({
    venueTypeCd: auth0Client.getDefaultVenue().venueTypeCd
  })
    this.refreshClaims();
    
    
    
  }
  




  loadmatches =async (claim)=>{
   
    await axios.get(`${SERVER_URL}/AIM/` + claim.id, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      }
    }).then((res)=>{
      //this.props.history.push('/');
      // Show saved successful
      let matches = [];
      if (res.data){
        for (var c=0; c< res.data.length; c++){
          res.data[c].tempClaimId = claim.id;
          // set the score notes if they exist
       
          matches.push(res.data[c]);
        }
       /* res.data.map(item=>{
          item.tempClaimId = claimID;
          matches.push(item);
        })
        */
      }
     this.setState({ 
       matchedItems: matches,
       matchCount: (matches) ? matches.length : 0,
       selectedClaimId: claim.id,
       selectedClaim:claim,
       isLoadingMatches:false
      });
  
     
    //ToastStore.success('Finished Loading');
  })
  .catch ((e)=>{
      
      this.setState({
        isLoadingMatches:false,
          error:e,
  
      })
      ToastStore.error(this.state.error.response.data);
  })



    
  }



getClaimsColumns =()=>{
  if (this.state.venueTypeCd==='A'){
    return this.getAviationClaimColumns();
  }else if(this.state.venueTypeCd==='S'){
    return stadiumColums;
  }else{
    return this.getDefaultClaimColumns();
  }
}

getMatchColumns =()=>{
  if (this.state.venueTypeCd==='A'){
    return airlineMatchColumns;
  }else if(this.state.venueTypeCd==='S'){
    return stadiumMatchColumns;
  }else{
    return this.getDefaultMatchedColumns();
  }
}



  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}

    // new claims
  onOpenModal = () => {
    this.setState({ showNewClaim: true });
  };
 
  onCloseModal = () => {
    this.setState({ showNewClaim: false });
  };

  claim=()=>{
    
        /*this.setState({
          showNewClaim: true,
        })*/
        this.props.history.push('/Claim/-1');

    
  }

  refreshHandler=()=>{
    this.initialClaimID = undefined;
    this.setState({initialClaimID:undefined});//why two place?
    this.refreshClaims();
  }

  refreshClaims=()=>{

    //console.log('Refreshing....' + this.initialClaimID);
    
    this.setState({
      claims: [], 
      refreshButtonTitle: 'Refreshing...',
      matchedItems: [],
      matchCount:0,
      isLoading:true
    });


    axios.get(`${SERVER_URL}/AIM/`,{
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
    'venueId' : auth0Client.getActiveVenuedId(),
    'claimFilterId' : (this.initialClaimID) ? this.initialClaimID : ''
    }
    }).then((res)=>{
      const claims  = res.data;
      if (claims){
         var filteredItems = claims;
        this.setState({
          claims: claims,
          filteredClaims : filteredItems,
          allCount: claims.length,
          refreshButtonTitle: 'Refresh (' + claims.length + ')',
          isLoading:false
        });
    
      }else{
        this.setState({
          claims: [],
          filteredClaims : [],
          allCount: 0,
          refreshButtonTitle: 'Refresh',
          isLoading:false
        });
      }
    }).catch((e)=>{
      ToastStore.error("An error occured. Please try again. Error:" + e.message);
      console.log(e);
    });
    
  }

  rebuildAllMatches=()=>{
    if (!window.confirm('BOUNTE will rematch all open claims for the last 30 days.  This make a take a minute or two.  Click ok to continue')){
      return;
    }
    this.setState({ rebuildTitle: 'Rematching...',  isLoading:true});
    //console.log('Starting Rematching...');
    axios.put(`${SERVER_URL}/AIM/rebuildMatches/`,
    {
      venueId:auth0Client.getActiveVenuedId(),
  
     }, 
    {
      headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,
      'venueId' : auth0Client.getActiveVenuedId()
    }
    }).then((res)=>{
     if (res.data){
        let count  = res.data.count;
      //  console.log('count' + count);
        this.setState({ rebuildTitle: 'Rematched ' + count + ' Claims',  isLoading:false});
      } else{
        this.setState({ rebuildTitle: 'Rematch All Claims',  isLoading:false});
      }
    }).catch((e)=>{
      console.log(e);
      ToastStore.error("An error occured. Please try again. Error:" + e.message);
    });
  }

  getDefaultClaimColumns=()=>{
    const columns = [
      { dataField: 'id', hidden:false,formatter:this.formatOpenClaim, className:'text-info', text: 'Action',style:{fontSize: '11px', cursor: 'pointer',  color:'#1f9bcf'}, sort: true,headerStyle:{width:'110px'}, events:{
        onClick:(e, column, columnIndex, row, rowIndex)=>{
        this.props.history.push('/Claim/' + row.id);
      }}},
      { dataField: 'firstName',text: 'First', sort: true, textAlign: 'left',style:{fontSize: '13px', cursor: 'pointer', fontWeight:500 },  headerStyle: { textAlign: 'center', width:'200px' }},
      { dataField: 'lastName',text: 'Last', sort: true, textAlign: 'left',style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, headerStyle: { textAlign: 'center', width:'200px' }},
      { dataField: 'category', formatter:ClaimFormatterFunctions.formatCat, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, text: 'category',sort: true, headerStyle: { textAlign: 'center', width:'120px' }},
      { dataField: 'lostItemShortDescription', text: 'Description',sort: true,  headerStyle:{ cursor: 'pointer', fontWeight:500, width:'400px'}, style:{fontSize: '13px'}},
   
      { dataField: 'claimDate', text: 'Claim Dt.',formatter:ClaimFormatterFunctions.formatDate, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, sort: true, headerStyle:{fontSize: '13px', width:'130px'}}, 
      { dataField: 'travelDate', text: 'Dt. Lost',formatter:ClaimFormatterFunctions.formatDate, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, sort: true, headerStyle:{ fontSize: '13px', width:'130px'}}, 
   
       
     
      { dataField: 'brand',  text: 'brand',sort: true, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500},headerStyle:{ fontSize: '13px', width:'120px'}},
      { dataField: 'color',  text: 'color',sort: true, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, headerStyle:{ fontSize: '13px', width:'100px'}},
      { dataField: 'locationLost',  text: 'location',sort: true,style:{fontSize: '13px', cursor: 'pointer'},formatter:ClaimFormatterFunctions.formatLocation,headerStyle:{ fontSize: '13px', width:'230px'} },
   
      
      { dataField: 'topMatchPct', classes:'text-center',formatter:formatMatchPct, text: 'Best Score',sort: true,style:{width:'100px', cursor: 'pointer', fontSize: '13px', fontWeight:800}, headerStyle:{ fontSize: '13px', width:'150px'}},
      { dataField: 'totalMatches', classes:'text-center', text: '# Matched',sort: true,headerStyle:{cursor: 'pointer', width:'150px'}},
    ];

    return columns;
  };
  
  getAviationClaimColumns=()=>{
    const columns = [
      { dataField: 'id', hidden:false,formatter:this.formatOpenClaim, text: 'Action',style:{fontSize: '11px', cursor: 'pointer', fontWeight:600, color:'#1f9bcf'}, sort: true, events:{
        onClick:(e, column, columnIndex, row, rowIndex)=>{
        this.props.history.push('/Claim/' + row.id);
      }}},

      { dataField: 'lastName', text: 'Name', sort: true,style:{cursor: 'pointer'},formatter: ClaimFormatterFunctions.formatName, textAlign: 'left', headerStyle: { textAlign: 'center' },  headerStyle: { textAlign: 'center', width:'200px' }},
      { dataField: 'category', formatter:ClaimFormatterFunctions.formatCat, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, text: 'category',sort: true, headerStyle: { textAlign: 'center', width:'120px' }},
      { dataField: 'lostItemShortDescription', text: 'Description',sort: true,className:"text-info",  headerStyle:{cursor: 'pointer', fontWeight:500, width:'400px'}, style:{fontSize: '13px'}},
      { dataField: 'brand',  text: 'brand',sort: true, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, headerStyle: { textAlign: 'center', width:'120px' }},
      { dataField: 'color',  text: 'color',sort: true, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500},  headerStyle: { textAlign: 'center', width:'120px' }},
    
      { dataField: 'claimDate', text: 'Claim Dt.',formatter:ClaimFormatterFunctions.formatDate, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, sort: true, headerStyle:{ fontSize: '13px',  width:'130px'}}, 
      { dataField: 'travelDate', text: 'Reported Lost',formatter:ClaimFormatterFunctions.formatDate, style:{fontSize: '13px', cursor: 'pointer', fontWeight:500}, sort: true, headerStyle:{ fontSize: '13px',  width:'180px'}}, 
   
 
  
      { dataField: 'locationLost',  text: 'location',sort: true, headerStyle:{ fontSize: '13px', width:'230px'}},
      
       { dataField: 'terminal',  text: 'Terminal',sort: false,hidden:false, headerStyle:{ fontSize: '13px', width:'130px'}},
      { dataField: 'gate', text: 'Gate',sort: false,hidden:false, headerStyle:{ fontSize: '13px', width:'100px'}},
       
      
      
      { dataField: 'topMatchPct', classes:'text-center',formatter:formatMatchPct, text: 'Best Score',sort: true,style:{width:'100px', cursor: 'pointer', fontWeight:500, headerStyle:{ fontSize: '13px', width:'130px'}}},
      { dataField: 'totalMatches', classes:'text-center', text: '#Matched',sort: true,style:{fontSize: '13px', cursor: 'pointer'},headerStyle:{width:'150px', cursor: 'pointer', fontWeight:500}},
    ];

    return columns;
  };
  viewScoreNotes = (cell, row) =>{
     // get the currently selected Claim
     // retrieve the matchResults
     // locate the lostItemId for the row
     // 
  }

  formatFoundItemLink=(cell, row)=>{

    if (row){
      return (
       
         <button className='btn btn-link' onClick={()=>{this.props.history.push('/Lostitem/' + row.id)}}>Open</button>
       
      )
    }
  }
  formatOpenClaim =()=>{
    return ( "Edit Claim" );
  }

  getDefaultMatchedColumns=()=>{

      const matchColumns = [


      
        { dataField: 'url', text: 'Picture', formatter: imageFormat, headerStyle: {width:'100px'}  },
        { dataField: 'shortDescription',classes:'text-primary', sort: true,formatter:LostItemFunctions.formatShortAndLong, text: 'Item', style:{fontSize: '13px'},filterable:true,  headerAlign: 'center', textAlign: 'left', headerStyle: { wordBreak: 'break-word', overflowWrap: 'break-word',}},
        { dataField: 'locationName',sort: true, text: 'Found Loc.',  textAlign: 'left', classes:'text-primary',style:{fontSize: '13px'}, headerStyle: (colum, colIndex) => {return {  textAlign: 'center' };}},
        { dataField: 'itemState',sort: true,formatter: LostItemFunctions.itemStatusDesc, text: 'Status', style:{fontSize: '13px', color:'white'}, textAlign: 'left', },
        { dataField: 'foundDate',sort: true,formatter: LostItemFunctions.formatDateTime, classes:'text-primary', text: 'Found', style:{fontSize: '13px'},  headerStyle: {width:'190px'}},
        { dataField: 'keywords',sort: false,hidden:true, text: 'keywords',  headerAlign: 'center',formatter:LostItemFunctions.formatKeywordAll, headerStyle: {width:'300px', textAlign: 'left', }},
        
        { dataField: 'id',sort: false,  text: 'Actions', classes:'text-primary text-center', headerAlign: 'center',style:{fontSize: '13px'}, textAlign: 'center', formatter:this.formatMatchLinkButton },
        { dataField: 'score',sort: false,  text: 'Score', classes:'text-primary text-center', headerAlign: 'center',style:{fontSize: '13px'}, textAlign: 'center', formatter:this.formatScore },
        { dataField: 'matchNotes',sort: false,  text: 'matchNotes', classes:'text-primary text-left', headerAlign: 'center', textAlign: 'center', formatter:this.formatMatchNoteLinkButton, headerStyle: {width:'220px', textAlign: 'left', }},
      ];
      return matchColumns;

  }

  formatScore=(cell,row)=>{
    if (row.score){
      let scoreStr = Math.round(row.score * 100);
      return (<h3 className='text-info'>{scoreStr}</h3>)
    }
  }

  getScoreValue=(valStr)=>{
    try{
      if (valStr){
        return Number.parseInt(valStr)
      }else{
        return 0;
      }

    }catch(e){

    }
  }
  formatMatchNoteLinkButton=(cell)=>{
    
    if (cell){
      //let notes = cell.replaceAll('|', ' ');
      let notes = cell.split('|');
      //return (<span style={{fontSize:'13px'}}>{notes}</span>)  <span style={{fontSize:'13px'}}>{label}</span>
      return <>{notes.map(label => {
        let score = 0;
        if (label && label.length>2){
          let scoreStr = label.substring(label.indexOf(':')+1, label.length)
          scoreStr = scoreStr.trim();//label.subString(label.indexOf(':'), label.length-1);
          score = this.getScoreValue(scoreStr)
        }
        if (score > 0){
          return(<li style={{fontSize:'11px' }} key={label}><b>{label}</b></li>)
        }else{
          return(<li style={{fontSize:'11px' }} key={label}>{label}</li>)
        }
        
       })}</>
    }else{
      return (null);
    }
    
 
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

formatMatchNotes =(cell)=>{
 try{

 
    if (cell){
      //let notes = cell.replaceAll('|', ' ');
      let notes = cell.split('|');
      //return (<span style={{fontSize:'13px'}}>{notes}</span>)  <span style={{fontSize:'13px'}}>{label}</span>
      return <>{notes.map(label => {
        let score = 0;
        let labelTitle ='';
        if (label && label.length>2){
          labelTitle = label.substring(0, label.indexOf(':')).replace('Score', '').trim();
          let scoreStr = label.substring(label.indexOf(':')+1, label.length)
          scoreStr = scoreStr.trim();//label.subString(label.indexOf(':'), label.length-1);
          score = this.getScoreValue(scoreStr)
         
        }
        if (score > 0){
          return(<div className='row' key={label}>
            <div className='col text-left text-success' style={{fontSize:'11px'}}><b>{this.capitalize(labelTitle)}</b></div>
            <div className='col text-right text-success' style={{fontSize:'11px'}}><b>{'YES'}</b></div>
            </div> )
        }else{
          return(<div className='row' key={label}>
            <div className='col text-left' style={{fontSize:'11px'}}>{this.capitalize(labelTitle)}</div>
            <div className='col text-right' style={{fontSize:'11px'}}>{'---'}</div>
            </div> )
        }
        
       })}</>
    }else{
      return (null);
    }
  }catch(e){
      return ('NA')
  }
 
}


  formatMatchLinkButton=(cell, row)=>{
    return(

     // <button type="button" className="btn btn-outline-success btn-sm" onClick={()=>this.ConfirmAndAssign(cell,row)}>Confirm</button>
     
     <button type="button" className="btn btn-success btn-sm" disabled={auth0Client.lfReadOnly===true} onClick={()=>{
       this.setState({ selectedLostItem : row, displayConfirmMatch:true})}}>Assign Match</button>
    )
  }

  renderRejectButton=(cell,row)=>{
    return(

      // <button type="button" className="btn btn-outline-success btn-sm" onClick={()=>this.ConfirmAndAssign(cell,row)}>Confirm</button>
      
      <button type="button" className="btn btn-outline-danger btn-sm" disabled={auth0Client.lfReadOnly===true} onClick={()=>{
        this.setState({ selectedLostItem : row, displayConfirmMatch:false}, ()=>this.reject())}}>Ignore Match</button>
     )
  }

  matchSelectedItem=(lostItemRow)=>{
    // Display the confirmation 
  }

  reject=async()=>{
    //if (!window.confirm("Are you sure you want to remove this match? .  Press OK to continue")){
    //  return;
    //}

    let reason= prompt("Provide a reason and click ok to continue", "Not an accurate match");
    if (!reason){return}

    if (!this.state.selectedLostItem) { alert('Select a valid Found Item'); return;}
    if (!this.state.selectedClaim) { alert('Select a claim row'); return;}

    await axios.post(`${SERVER_URL}/AIM/Reject/`, {
        lostItemId: this.state.selectedLostItem.id,
        claimId: this.state.selectedClaim.id,
        rejectNote:reason,
  
    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    }).then((res)=>{
      
          if(res.status!==200){
            ToastStore.error("An error occured: " + res.statusText);
          }else{
           
            ToastStore.success(res.statusText);
            this.setState({
              displayConfirmMatch:false
            })
            this.refreshClaims();
          }
      }).catch ((e)=>{
        console.log(e);
        ToastStore.error("An error occured: " + e.message);
       
    })
  


  }

  rejectAll=async()=>{
    if (!this.state.selectedClaim) { alert('Select a claim row'); return;}
    let confirmResult = window.confirm('Are you sure you want to reject all the suggested matches for this claim?');
    if (!confirmResult){return}
          await axios.post(`${SERVER_URL}/AIM/Reject/`, {
            lostItemId: undefined,
            claimId: this.state.selectedClaim.id,
            rejectNote:'',

        }, {
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId()
          
          }
        }).then((res)=>{
          
              if(res.status!==200){
                ToastStore.error("An error occured: " + res.statusText);
              }else{
              
                ToastStore.success(res.statusText);
                this.setState({
                  displayConfirmMatch:false
                })
                this.refreshClaims();
              }
          }).catch ((e)=>{
            console.log(e);
            ToastStore.error("An error occured: " + e.message);
          
        })
  }



  confirmAndAssign=async (notifyByEmail)=>{
    
    //console.log('notifyByEmail: ' + notifyByEmail)
     if (!window.confirm("Are you sure you want to assign the selected claim? .  Press OK to continue")){
       return;
     }



    if (!this.state.selectedLostItem) { alert('Select a valid Found Item'); return;}
    if (!this.state.selectedClaim) { alert('Select a claim row'); return;}

     axios.post(`${SERVER_URL}/AIM/Assign/`, {
        lostItemId: this.state.selectedLostItem.id,
        claimId: this.state.selectedClaim.id,
        notifyByEmail :notifyByEmail,
        includeImage: this.state.includeImage
  
    }, {
      headers: { 
        'Authorization': `Bearer ${auth0Client.getIdToken()}`,
        'venueId': auth0Client.getActiveVenuedId()
      
      }
    }).then((res)=>{
      
          if(res.status!==200){
            ToastStore.error("An error occured: " + res.statusText);
          }else{
           
            ToastStore.success("Item assigned");
            this.setState({
              displayConfirmMatch:false
            })
            this.refreshClaims();
          }
      }).catch ((e)=>{
        console.log(e);
        ToastStore.error("An error occured: " + e.message);
       
    })
  
  }
  

  renderMatches=()=>{

 

      return (

        <div  style={{backgroundColor:'white'}} >
         
         
     
         {this.state.matchedItems === null && <p>Loading Matches...</p>}

        
        
          <BootstrapTable
            bootstrap4
            keyField='id' 
            data={ this.state.matchedItems } 
            columns={ this.getMatchColumns()} 
            
            defaultSorted={defaultSorted}
          
            rowStyle={{color: 'white'}}
            
            condensed
            rowEvents={this.rowMatchEvents}
            
                
          />
       </div>
     
  
      )
    



  }
  renderLocationFound = (lostitem)=>{
    if (this.state.venueTypeCd==='A'){
      return (
        <div>
            <div className='row' >     
                <div className='col text-left text-primary' style={{fontSize:'13px'}}><b>{this.capitalize('Airport:')}</b></div>
                <div className='col text-right text-info' style={{fontSize:'13px'}}><b>{lostitem.airportCd}</b></div>
            </div> 
          <div className='row' >     
              <div className='col text-left text-primary' style={{fontSize:'13px'}}><b>{this.capitalize('Flight:')}</b></div>
              <div className='col text-right text-info' style={{fontSize:'13px'}}><b>{lostitem.flightNumber}</b></div>
              </div> 
          <div className='row' >     
              <div className='col text-left text-primary' style={{fontSize:'13px'}}><b>{this.capitalize('seat:')}</b></div>
              <div className='col text-right text-info' style={{fontSize:'13px'}}><b>{lostitem.seat}</b></div>
          </div> 
          <div className='row' >     
            <div className='col text-left text-primary' style={{fontSize:'13px'}}><b>{this.capitalize('Terminal:')}</b></div>
            <div className='col text-right text-info' style={{fontSize:'13px'}}><b>{lostitem.terminal}</b></div>
          </div> 
          <div className='row' >     
            <div className='col text-left text-primary' style={{fontSize:'13px'}}><b>{this.capitalize('gate:')}</b></div>
            <div className='col text-right text-info' style={{fontSize:'13px'}}><b>{lostitem.gate}</b></div>
          </div> 
          </div>

      )
    }else{
      return (
          <span className="text-info">{lostitem.locationName}</span>
      )
    }
  }
  renderMatchItem=(lostitem)=>{
    let scoreStr ="0"
    if (lostitem.score){
       scoreStr = Math.round(lostitem.score * 100);
      //return (<h3 className='text-info'>{scoreStr}</h3>)
    }
      return(

          <div className="card " key={lostitem.id}>
            <div className="card-header">
                <div className="row">
                  <div className="col"><h5>{lostitem.shortDescription}</h5></div> 
                  
                  <div className="col text-right"><h5 className='text-info'>score: {scoreStr}</h5></div>
                </div>
              </div>
            <div className="card-body">
            <div className="row">
                <div className="col"> <img  src={lostitem.url} width={100} alt={lostitem.shortDescription} onClick={()=>{this.setState({selectedImageUrl:lostitem.url, displayLargeImageModal:true})}} /></div> 
                <div className="col-5 text-left"> <b>Description:</b><br/> 
                    <span className="text-info"><b>{lostitem.longDescription}</b></span><br/>
                    <b>Keywords:</b><br/><span className="text-muted"><small>{lostitem.keywords}</small></span><br/>
                    <b>Location Found: </b><span className="text-info" style={{fontSize:'13px', fontWeight:'bold'}}> {lostitem.locationName}</span><br/>
                    </div>  
                <div className="col text-left"> <b>Date Found:</b><br/><span className="text-info" style={{fontSize:'13px', fontWeight:'bold'}}> { LostItemFunctions.formatDateTime(lostitem.foundDate, null)}</span><br/>{this.renderLocationFound(lostitem)}</div>    
                <div className="col text-center ">
                  <b>Score Details:</b> <br/>
                  <div className="col text-left" style={{backgroundColor:'white', borderWidth:1, borderColor:'grey'}}>{this.formatMatchNotes(lostitem.matchNotes) }</div> 
                  </div>
                  
              </div>
              <div class="row">
                    <div className="col text-right">{this.formatMatchLinkButton(lostitem.id, lostitem)}</div>
                    <div className="col text-right">{this.renderRejectButton(lostitem.id, lostitem)}</div>
                  </div>  
            </div>
             
          
            
          </div>


       
            

       
      )
  }

renderRejectAllButton=()=>{
   return(
    <button type="button" className="btn btn-outline-danger btn-sm" onClick={()=>this.rejectAll()}>Reject All</button>
   ) 
}


renderMatchRowDetails=(row)=>{
  if (this.state.matchedItems){
    return(
      <div className="container-lg" style={{backgroundColor:'white', padding:0}} key={row.id}>
       <div className='row'>
          <div className='col-6 text-left'>
                <h5 className='text-primary text-success'>Suggested Items:</h5>
          </div>
          <div className='col-6 text-right'>
                {this.renderRejectAllButton()}
          </div>
       </div>
      <hr/>

      {this.state.matchedItems.map((item)=>{
          return this.renderMatchItem(item);
      }) }
     
    </div>
    )
  }else{
    return ("loading...")
  }
}

renderTitle=()=>{
    if (this.state.initialClaimID){
      return (  
                <div>
                  <h5 className='text-info'>Auto-Matches for 1 selected claim.</h5>
                  <h6>tap refresh to load all claims</h6>
                </div>
      )
    }else{
      return (  <h5>Claims With Auto-Matches ({(this.state.claims) ? this.state.claims.length : 0})</h5>)
    }
}


  renderGrid=()=>{
    if(this.state.isLoading){
      return(
        <div >
          <br/> <br/> <br/> <br/> <br/><br/><br/>
       
        <h5 className='text-center'>Processing AIM results....Please Wait</h5>

        </div>
      )
    }else{

    
    return (

      <div className="table-container">
       
       {this.renderToast()}
   

        <ToolkitProvider 
        bootstrap4
          keyField='id' 
          data={ this.state.filteredClaims } 
          columns={ this.getClaimsColumns() } 
          condensed
          
          search
          >
          {
    props => (
      <div>
       <div className='row'>
       <div className='col-3 text-left'>
       <SearchBar { ...props.searchProps } />
          </div>
          <div className='col text-center'>
              {this.renderTitle()}
          </div>
        </div>
        
      
        <BootstrapTable
         headerClasses="table-active"
         maxHeight ={"90%"}
         hover
          condensed
          rowEvents={this.rowEvents}
          
          { ...props.baseProps }
          pagination={ paginationFactory(paginationOption) }
          
          
          expandRow={{
            onlyOneExpanding: true,
            showExpandColumn: true,
            
            renderer: row => (
              <div style={{backgroundColor:'white', padding:0}}>
               
               {this.renderMatchRowDetails(row)}
               
              </div>
            ),
            onExpand: (row, isExpand, rowIndex, e) => {
             if (isExpand){
              this.loadmatches(row);
             }
            },
            parentClassName: 'parent-expand-foo',
          }}
        />
      </div>
    )
  }</ToolkitProvider>

      </div>


    )
  }
    
  }


  renderMatchingChildTable=(row)=>{
    return(
      <table class="table">
  <thead>
    <tr>
      <th scope="col">picture</th>
      <th scope="col">Item</th>
      <th scope="col">Desc</th>
      <th scope="col">Date Found</th>
    </tr>
  </thead>
  <tbody>
  {this.state.matchedItems.map((item)=>{
          return (
            <tr>
            <th scope="row">open</th>
            <td><img  src={item.url} width={100} alt={item.shortDescription} /></td>
            <td>{item.shortDescription}</td>
            <td>Column content</td>
          </tr>
          )
      }) }
   
   
  </tbody>
</table>
    )
  }




  expandRowRenderer=(row)=>{
    return ( this.renderMatches() )
  }
 


  filterButtonClick=(event)=>{

    const target = event.target;
    

    var filter = 'O';
    switch(target.id){
      case 'optOpen': filter = 'O'; break;
      case 'optShip':filter = 'READYTOSHIP'; break;
      case 'optPickup':filter = 'WP'; break;
      case 'optClosed':filter = 'CS'; break;
       case 'optArchived':filter = 'A'; break;
       case 'optLabelRequested':filter = 'LABELREQUESTED'; break;
      case 'optAll':filter = ''; break;
      default: filter = 'O';


    }
    var filteredItems = null;
 
    if (target.id==='optUnlinked'){
       filteredItems = this.state.claims.filter((claimItem) =>{
        if (claimItem.lostItemId === ''){
          return claimItem;
        }else{ return null;}
      });
    }else if (target.id==='optAll'){
       filteredItems = this.state.claims;
     
    }else if (target.id==='optClosed'){
      filteredItems = this.state.claims.filter((claimItem) =>{
      if (claimItem.status === 'CS' || claimItem.status === 'CP'){
        return claimItem;
      }else{ return null;}
    });
   }else {
       filteredItems = this.state.claims.filter((claimItem) =>{
        if (claimItem.status === filter){
          return claimItem;
        }else{ return null;}
      });
    }


    this.setState({
      filteredClaims: filteredItems
    });
return true;


  }


renderAIM =()=>{
return (
//style={{overflowY:'auto', maxHeight:500}}
  <div className="container-fluid">


  <div className='row'>
  <div className='col-8 text-left'>
    
  <h4>AIM : Found Item Matching</h4>
    </div>
    <div className='col-4 text-right'>
   
    <button type="button" className="btn btn-primary  btn-sm"  id="refresh" onClick={this.refreshHandler} >{this.state.refreshButtonTitle}</button>
    <span>&nbsp;&nbsp;&nbsp;</span>
    <button type="button"  className="btn btn-warning btn-sm"  id="refresh" onClick={this.rebuildAllMatches} >{this.state.rebuildTitle}</button>
   
    
    </div>
  </div>
  


  

  
  <div className='row'>
    <div className='col text-left'>
        {this.renderGrid()}
     
    </div>
  </div>
<br/><hr/>
     
<Modal open={this.state.displayConfirmMatch} onClose={()=>{this.setState({displayConfirmMatch:false})}} center>
      
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm the Match</h5>
                
              </div>
              <div className="modal-body">
                <p>Your assigning the selected item, <span className='text-primary'><b> {(this.state.selectedLostItem) ? this.state.selectedLostItem.shortDescription : ''} </b></span> 
                to <span className='text-success'><b>{(this.state.selectedClaim) ? this.state.selectedClaim.firstName + ' ' + this.state.selectedClaim.lastName : ''} </b></span></p>
              
              <br/>
              <h5>Notification</h5>
              {this.renderContactClaimSection()}
              </div>
              <br/>
              <Toggle id='expensive' labelRight="Include image in email" checked={this.state.includeImage} onToggle={value => this.setState({includeImage:value})} /> 

              <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={()=>{this.setState({displayConfirmMatch:false})}}>Close</button>
                <button type="button" className="btn btn-primary" onClick={()=>this.confirmAndAssign(false)}>Confirm</button>
               {(this.state.selectedClaim && this.state.selectedClaim.email)? ( <button type="button" onClick={()=>this.confirmAndAssign(true)} className="btn btn-success">Confirm &amp; Send Notification</button>) :  ( <button disabled type="button" onClick={()=>this.confirmAndAssign(true)} className="btn btn-success">Confirm &amp; E-Mail Notification</button>)}
              </div>
            </div>
          </div>
       
      
      </Modal>  
     {this.renderLargeImage()}
  </div>

)
}

renderLargeImage=()=>{

  return(

 
      <Modal open={this.state.displayLargeImageModal} onClose={()=>this.setState({displayLargeImageModal:false})} center>
          
          <img src={this.state.selectedImageUrl} style={{width:'100%', height:'auto'}} alt='Click or tap to enlarge'/><br/>
          <button title="Close"    className="btn btn-info" onClick={()=>{this.setState({displayLargeImageModal:false})}}>Close </button>
      </Modal>

      )
}


renderContactClaimSection=()=>{
  if (this.state.selectedClaim){
    return(
      <div>
      <p className="text-primary"><b>Phone Number: </b> {(this.state.selectedClaim.phone) ? (this.state.selectedClaim.phone) : 'Not Provided'}</p>
      <p className="text-primary"><b>Email:</b> {(this.state.selectedClaim.email) ? (this.state.selectedClaim.email) : 'Not Provided'}</p>
      
     
      </div>
    )
  }
}


  render() {

   


    return (
          this.renderAIM()
    )
  }
}

export default withRouter(AIM);